import type { ReceiptTemplate } from '../schema';

export const westernUnionTemplate: ReceiptTemplate = {
  id: 'western-union',
  name: 'Western Union Receipt',
  brand: 'WESTERN UNION',
  description: 'Western Union transfer receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'wu-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/western-union.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: ['MONEY TRANSFER RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wu-mtcn',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'MTCN (TRACKING NUMBER)\n847-291-0384', fontSize: 14, showDivider: true, dividerStyle: 'dashed', isBold: true },
    },
    {
      id: 'wu-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'sender', label: 'Sender:', value: 'JOHN DOE' },
          { id: 'receiver', label: 'Receiver:', value: 'MIKE WAZOWSKI' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'dest', label: 'Country:', value: 'MEXICO' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'wu-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'send', label: 'TRANSFER AMOUNT', value: '300.00', isBold: false, isLarge: false },
          { id: 'fee', label: 'TRANSFER FEE', value: '9.99', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '309.99', isBold: true, isLarge: true },
          { id: 'receive', label: 'PAYOUT AMOUNT', value: 'MXN 5,145.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wu-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'KEEP THIS RECEIPT\nGIVE MTCN TO RECEIVER', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

